module.exports = __webpack_public_path__ + "img/History.4e6c416c.svg";